'use strict';

var User = Mario.Model.extend({
    modelName: 'User',
    url: 'user'
});
module.exports = User;